import * as React from 'react';

export const FileTXTIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="35"
    height="45"
    viewBox="0 0 35 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <g opacity="0.3">
      <path
        opacity="0.3"
        d="M29.0979 10.2604C27.9589 10.2593 26.8669 9.80634 26.0615 9.00096C25.2562 8.19557 24.8032 7.10355 24.8021 5.96456V0H5.60627C2.51003 0 1.60933e-05 2.51 1.60933e-05 5.60623V39.4021C0.00461092 42.4932 2.5151 45 5.60627 45H28.6479C29.3843 45.0003 30.7292 45 30.7292 45H32.5C33.47 45 34.2563 44.2144 34.2563 43.2444C34.2563 41.7705 34.2563 39.8362 34.2563 39.3938V10.2521L29.0979 10.2604Z"
        fill="#76A9FA"
      />
    </g>
    <path
      d="M34.2566 10.2604H29.0982C27.9593 10.2593 26.8672 9.80634 26.0618 9.00096C25.2565 8.19557 24.8035 7.10355 24.8024 5.96456V0L34.2566 10.2604Z"
      fill="#76A9FA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7182 15.6459V29.353C10.7301 29.362 10.7547 29.3745 10.7931 29.3745H23.3748C23.4131 29.3745 23.4378 29.362 23.4497 29.353V15.6459C23.4378 15.6369 23.4131 15.6245 23.3748 15.6245H10.7931C10.7547 15.6245 10.7301 15.6369 10.7182 15.6459ZM9.1904 15.6245C9.1904 14.715 9.97674 14.0967 10.7931 14.0967H23.3748C24.1911 14.0967 24.9774 14.715 24.9774 15.6245V29.3745C24.9774 30.2839 24.1911 30.9022 23.3748 30.9022H10.7931C9.97674 30.9022 9.1904 30.2839 9.1904 29.3745V15.6245ZM12.246 17.9161C12.246 17.4942 12.588 17.1522 13.0099 17.1522H21.158C21.5799 17.1522 21.9219 17.4942 21.9219 17.9161C21.9219 18.338 21.5799 18.68 21.158 18.68H13.0099C12.588 18.68 12.246 18.338 12.246 17.9161ZM12.246 20.9717C12.246 20.5498 12.588 20.2078 13.0099 20.2078H21.158C21.5799 20.2078 21.9219 20.5498 21.9219 20.9717C21.9219 21.3936 21.5799 21.7356 21.158 21.7356H13.0099C12.588 21.7356 12.246 21.3936 12.246 20.9717ZM12.246 24.0272C12.246 23.6054 12.588 23.2633 13.0099 23.2633H17.5932C18.0151 23.2633 18.3571 23.6054 18.3571 24.0272C18.3571 24.4491 18.0151 24.7911 17.5932 24.7911H13.0099C12.588 24.7911 12.246 24.4491 12.246 24.0272Z"
      fill="#76A9FA"
    />
    <rect
      x="6.87485"
      y="33.3335"
      width="20.8333"
      height="7.69176"
      rx="1.5625"
      fill="#76A9FA"
    />
    <path
      d="M11.3897 38.5261C11.6892 38.5261 11.932 38.7689 11.932 39.0684C11.932 39.3679 11.6892 39.6107 11.3897 39.6107H11.3509C11.0514 39.6107 10.8086 39.3679 10.8086 39.0684C10.8086 38.7689 11.0514 38.5261 11.3509 38.5261H11.3897Z"
      fill="white"
    />
    <path
      d="M15.7195 35.125V35.9888H14.5007V39.6109H13.4102V35.9888H12.2033V35.125H15.7195Z"
      fill="white"
    />
    <path
      d="M18.8987 39.6109L17.9529 38.2146L17.1399 39.6109H15.8972L17.3308 37.3016L15.8524 35.125H17.1399L18.0603 36.4766L18.854 35.125H20.0907L18.6764 37.3836L20.1862 39.6109H18.8987Z"
      fill="white"
    />
    <path
      d="M23.828 35.125V35.9888H22.6107V39.6109H21.5187V35.9888H20.3133V35.125H23.828Z"
      fill="white"
    />
  </svg>
);

export default FileTXTIcon;
